/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { ButtonText, FormSilverpopRequiredFields, FormTypes } from '@powdr/constants';

export const ScanChallenge2526FollowUpForm = ({
  reCaptchaPublicKey,
  processForm,
  isUserVerified,
  setUserVerified,
  handleCaptchaExpiry,
  buttonText = null,
}) => {
  const captchaRef = useRef();
  const [passType, setPassType] = useState();

  return (
    <form
      id="scan-challenge-25-26-follow-up"
      onSubmit={(e) => {
        const phoneInput = e?.target?.querySelector('#container_COLUMN12');
        if (phoneInput) {
          phoneInput.value = phoneInput.value.replace(/\D/g, '');
        }
        processForm(e, null, null, captchaRef, FormTypes.SILVERPOP);
      }}
    >
      <input name="CONTACT_LIST_ID" type="hidden" value="17207763" />

      <label className="input-label">
        Email *
        <input
          className="form-control"
          type="text"
          name={FormSilverpopRequiredFields.EMAIL}
          id="control_EMAIL"
          label="Email Address"
          placeholder="Email Address"
          required
        />
      </label>

      <label className="input-label">
        First Name *
        <input
          name="First Name"
          id="container_COLUMN3"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Last Name *
        <input
          name="Last Name"
          id="container_COLUMN4"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Address *
        <input
          name="Address"
          id="container_COLUMN5"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        City *
        <input
          name="city"
          id="control_COLUMN6"
          className="form-control"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        State *
        <select className="form-control" id="control_COLUMN7" name="state" required>
          <option selected="selected">
            - select a state -
          </option>
          <option value="AL">Alabama</option>
          <option value="AK">Alaska</option>
          <option value="AB">Alberta</option>
          <option value="AZ">Arizona</option>
          <option value="AR">Arkansas</option>
          <option value="BC">British Columbia</option>
          <option value="CA">California</option>
          <option value="CO">Colorado</option>
          <option value="CT">Connecticut</option>
          <option value="DE">Delaware</option>
          <option value="DC">District of Columbia</option>
          <option value="FL">Florida</option>
          <option value="GA">Georgia</option>
          <option value="HI">Hawaii</option>
          <option value="ID">Idaho</option>
          <option value="IL">Illinois</option>
          <option value="IN">Indiana</option>
          <option value="IA">Iowa</option>
          <option value="KS">Kansas</option>
          <option value="KY">Kentucky</option>
          <option value="LA">Louisiana</option>
          <option value="ME">Maine</option>
          <option value="MB">Manitoba</option>
          <option value="MD">Maryland</option>
          <option value="MA">Massachusetts</option>
          <option value="MI">Michigan</option>
          <option value="MN">Minnesota</option>
          <option value="MS">Mississippi</option>
          <option value="MO">Missouri</option>
          <option value="MT">Montana</option>
          <option value="NE">Nebraska</option>
          <option value="NV">Nevada</option>
          <option value="NB">New Brunswick</option>
          <option value="NH">New Hampshire</option>
          <option value="NJ">New Jersey</option>
          <option value="NM">New Mexico</option>
          <option value="NY">New York</option>
          <option value="NL">Newfoundland and Labrador</option>
          <option value="NC">North Carolina</option>
          <option value="ND">North Dakota</option>
          <option value="NT">Northwest Territories</option>
          <option value="NS">Nova Scotia</option>
          <option value="NU">Nunavut</option>
          <option value="OH">Ohio</option>
          <option value="OK">Oklahoma</option>
          <option value="ON">Ontario</option>
          <option value="OR">Oregon</option>
          <option value="PA">Pennsylvania</option>
          <option value="PE">Prince Edward Island</option>
          <option value="QC">Quebec</option>
          <option value="RI">Rhode Island</option>
          <option value="SK">Saskatchewan</option>
          <option value="SC">South Carolina</option>
          <option value="SD">South Dakota</option>
          <option value="TN">Tennessee</option>
          <option value="TX">Texas</option>
          <option value="UT">Utah</option>
          <option value="VT">Vermont</option>
          <option value="VA">Virginia</option>
          <option value="WA">Washington</option>
          <option value="WV">West Virginia</option>
          <option value="WI">Wisconsin</option>
          <option value="WY">Wyoming</option>
          <option value="YT">Yukon</option>
        </select>
      </label>

      <label className="input-label">
        Postal Code *
        <input
          className="form-control"
          id="control_COLUMN8"
          name="Postal Code"
          type="text"
          required
        />
      </label>

      <label className="input-label">
        Phone Number *
        <input
          className="form-control"
          id="container_COLUMN12"
          name="Phone Number"
          type="tel"
          required
        />
      </label>

      <label className="input-label">
        Birthdate *
        <input
          className="form-control"
          type="date"
          name="birthdate"
          label="Birthdate"
          placeholder="MM/DD/YYYY"
          required
        />
      </label>

      <p className="input-label" style={{ marginBottom: '10px' }}>
        What pass type do you have? (Please select one)
      </p>

      <ul className="l-group">
        <li className="l-item">
          <input
            className="radio"
            id="passTypeIkon"
            value="ikon"
            type="radio"
            name="passType"
            checked={passType === 'ikon'}
            onChange={() => setPassType('ikon')}
          />
          <label htmlFor="passTypeIkon">Ikon Pass (Full or Base)</label>
        </li>

        <li className="l-item">
          <input
            className="radio"
            id="passTypeCopper"
            value="copper"
            type="radio"
            name="passType"
            checked={passType === 'copper'}
            onChange={() => setPassType('copper')}
          />
          <label htmlFor="passTypeCopper">
            Copper Season Pass or Four Pack
          </label>
        </li>
      </ul>

      {passType === 'ikon' && (
        <label className="input-label" htmlFor="container_COLUMN100" style={{ marginBottom: '10px' }}>
          What is your 25/26 Ikon Pass Number (Starting with I9)? *
          <input
            type="text"
            id="Copper 2526 Pass Number"
            name="Copper 2526 Pass Number"
            placeholder="Ikon Pass #"
            className="form-control"
            required={passType === 'ikon'}
          />
        </label>
      )}

      {passType === 'copper' && (
        <label className="input-label" htmlFor="container_COLUMN100" style={{ marginBottom: '10px' }}>
          What is your 25/26 Copper Pass Number (16-digit #)? *
          <input
            type="text"
            id="Copper 2526 Pass Number"
            name="Copper 2526 Pass Number"
            placeholder="Copper Pass #"
            className="form-control"
            required={passType === 'copper'}
          />
        </label>
      )}

      <ReCAPTCHA
        ref={captchaRef}
        className="recaptcha"
        sitekey={reCaptchaPublicKey}
        theme="light"
        size="normal"
        onChange={() => setUserVerified(true)}
        onExpired={handleCaptchaExpiry}
      />

      <button type="submit" value="Submit" disabled={!isUserVerified}>
        {buttonText || ButtonText.SUBMIT}
      </button>
    </form>
  );
};

ScanChallenge2526FollowUpForm.propTypes = {
  reCaptchaPublicKey: PropTypes.string.isRequired,
  processForm: PropTypes.func.isRequired,
  setUserVerified: PropTypes.func.isRequired,
  isUserVerified: PropTypes.bool.isRequired,
  handleCaptchaExpiry: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
};
